var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('tab'),_c('router-view'),_c('div',{staticClass:"cursor-pointer fixed f1eee6-bg p10",staticStyle:{"right":"0","top":"50%"},on:{"click":_vm.scrollTop}},[_c('img',{attrs:{"width":"25","src":require("@/assets/btn/up.png"),"alt":""}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }